import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft, Home } from 'lucide-react';

export const FloatingBackButton = ({ className = '' }) => {
  const navigate = useNavigate();
  
  return (
    <motion.div 
      initial={{ opacity: 0, x: -20 }}
      animate={{ opacity: 1, x: 0 }}
      className={`fixed top-4 left-4 z-50 flex items-center gap-2 ${className}`}
    >
      <button
        onClick={() => navigate(-1)}
        className="flex items-center gap-2 px-4 py-2.5 rounded-xl bg-black/40 backdrop-blur-xl border border-white/10 hover:bg-black/60 hover:border-white/20 transition-all group shadow-lg"
        data-testid="floating-back-btn"
      >
        <ArrowLeft className="w-4 h-4 text-white/70 group-hover:text-white transition-colors" />
        <span className="text-white/70 group-hover:text-white text-sm font-medium transition-colors">Back</span>
      </button>
      
      <button
        onClick={() => navigate('/dashboard')}
        className="flex items-center gap-2 px-4 py-2.5 rounded-xl bg-black/40 backdrop-blur-xl border border-white/10 hover:bg-black/60 hover:border-white/20 transition-all group shadow-lg"
        data-testid="floating-home-btn"
      >
        <Home className="w-4 h-4 text-white/70 group-hover:text-white transition-colors" />
        <span className="text-white/70 group-hover:text-white text-sm font-medium transition-colors">Home</span>
      </button>
    </motion.div>
  );
};

export default FloatingBackButton;
